import React from 'react';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';
import SectionTitle from '../../../components/SectionTitle';
import SecondaryNav from '../../../components/SecondaryNav';
import { getWebNotificationsPunchingNumber } from '../../../js/notifications/selectors';

const messages = defineMessages({
  title: {
    id: 'Puncher.title',
    defaultMessage: 'Puncher',
  },
  punchings: {
    id: 'Puncher.punchings',
    defaultMessage: 'Punchings',
  },
  notifications: {
    id: 'Puncher.notifications',
    defaultMessage: 'Notifications',
  },
});

const Puncher = ({
  intl: { formatMessage },
  notificationsQuantity,
  children,
}) => {
  const nav = [
    {
      id: 'Puncher.punchings',
      href: '/puncher/punchings',
      label: messages.punchings,
    },
    {
      id: 'Puncher.notifications',
      href: '/puncher/notifications',
      label: messages.notifications,
      notifications: notificationsQuantity,
    },
  ];
  return (
    <div className="border rounded bg-white h-100">
      <SectionTitle>{formatMessage(messages.title)}</SectionTitle>
      <SecondaryNav tabs={nav} />
      <div className="yn-section-with-nav-scrolling">{children}</div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    notificationsQuantity: getWebNotificationsPunchingNumber(state),
  };
}
export default injectIntl(connect(mapStateToProps)(Puncher));
